import { render, staticRenderFns } from "./ReferralModal.vue?vue&type=template&id=4a20e31e&"
import script from "./ReferralModal.vue?vue&type=script&lang=ts&"
export * from "./ReferralModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports